import { render } from "./ChildrenField.vue?vue&type=template&id=4542665e&ts=true"
import script from "./ChildrenField.vue?vue&type=script&lang=ts"
export * from "./ChildrenField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__